import { Box, BoxProps, Button, FormControl, FormHelperText, FormLabel, Grid, GridItem, HStack, Icon, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FiCheck } from "react-icons/fi";
import { geraCor, geraCores } from "../../utils/functions/gera-cor";


//@ts-ignore
export interface IInputFieldProps extends BoxProps {
    value: any,
    onChange: (e: any) => void,
    onBlur?: (e: any) => void,
    name: string,
    error: string | undefined,
    label?: string,
    descLabel?: string,
    isRequired?: boolean,
    isDisabled?: boolean,
}


export const ColorField = ({ name, error, onChange, value, onBlur, label, descLabel, isRequired, isDisabled, ...rest }: IInputFieldProps) => {

    let cores = [
        "#ffad9f",
        "#725753",
        "#117f09",
        "#4829f9",
        "#9a3c99",
        "#b0110a",
        "#fca622",
        "#b80cbb",
        "linear-gradient(135deg, rgba(190,35,35,1) 0%, rgba(255,165,142,1) 46%);",
        "linear-gradient(180deg,#190a05,#870000)!important",
        "linear-gradient(180deg,#727a17,#414d0b)!important",
        "linear-gradient(180deg,#ac4f73,#fe9e96 66%)!important",
        "linear-gradient(128deg,#742b3e 19%,#c04767 90%)!important",
        "linear-gradient(138deg,#13aa52,#00662b 90%)!important",
        "radial-gradient(circle,#294f83,#162c4a)!important",
        "linear-gradient(1turn,#d64759 10%,#da7352 360%)!important",
        "linear-gradient(1turn,#fd6f46 10%,#fb9832 360%)!important",
        "linear-gradient(1turn,#224e4d 10%,#083023 360%)!important",
        "radial-gradient(circle farthest-corner at 10% 20%,#005f68 0,#0f9ca8 90%)!important",
        "radial-gradient(circle farthest-corner at 10% 20%,#970a82 0,#212121 100.2%)!important",
        "linear-gradient(91.7deg,#32194f -4.3%,#7a6595 101.8%)!important",
        "linear-gradient(171.8deg,#056f92 13.5%,#063954 78.6%)!important",
        "linear-gradient(111.7deg,#fbc606 2.4%,#e0525f 28.3%,#c24e9a 46.2%,#20adbe 79.4%,#169e5f 100.2%)!important",
        "linear-gradient(180.5deg,teal 8.5%,#aece64 118.2%)!important",
    ]

    const [index, setIndex] = useState<any>(1);

    let [generated, setGenerated] = useState<{ cores: string[], geradas: string[] }>({ cores, geradas: [] });

    let onGenereteColors = () => {
        for (let i = 0; i < 20; i++) {
            let geradas = geraCores(23);
            let newColors = { cores, geradas: [value, ...geradas] };
            setGenerated(newColors);
        }
    }

    useEffect(() => {
        setIndex(value);
        onGenereteColors()
    }, [])


    return (
        <FormControl isRequired={isRequired} isDisabled={isDisabled}>
            <FormLabel fontSize={{ base: 12, '2xl': 14 }} fontWeight={`bold`} color={error ? 'red.500' : rest['color'] ? rest['color'] : 'gray.700'}>{label}{descLabel && <Text as={`span`} fontWeight={`normal`} textTransform={`lowercase`}>&nbsp;{descLabel}</Text>}</FormLabel>
            <Grid
                templateColumns={`repeat(12, 1fr)`}
                gap={3}
            >
                {/*  <GridItem
                    borderBottomWidth={1}
                    colSpan={12}
                    pb={3}
                >
                    <Text
                        fontSize={12}
                        fontWeight={`bold`}
                        textTransform={'uppercase'}
                    >
                        Cores Fixas
                    </Text>
                </GridItem> */}
                {generated?.cores.map((c, k) => (
                    <GridItem
                        key={k.toString()}
                        colSpan={{ base: 1, md: 1 }}
                    >
                        <Box
                            borderRadius={36}
                            borderWidth={1}
                            borderColor={index === c ? c : 'transparent'}
                            p={0.5}
                        >
                            <Box
                                {...rest}
                                w={`35px`}
                                h={`35px`}
                                bg={c}
                                borderWidth={1}
                                borderColor={index === c ? c : 'transparent'}
                                p={2}
                                borderRadius={36}
                                display={`flex`}
                                alignItems={`center`}
                                justifyContent={`center`}
                                _hover={{
                                    cursor: 'pointer'
                                }}
                                onClick={() => {
                                    setIndex(c)
                                    onChange(c)
                                }}
                            >
                                {index && index === c &&

                                    <Icon
                                        as={FiCheck}
                                        color={`white`}
                                        fontVariant={`solid`}
                                        w={'20px'}
                                        h={'20px'}
                                    />
                                }
                            </Box>
                        </Box>
                    </GridItem>
                ))}


                {/* <GridItem
                    mt={5}
                    borderBottomWidth={1}
                    pb={3}
                    colSpan={12}
                >
                    <HStack
                        justifyContent={`space-between`}
                    >
                        <Text
                            fontSize={12}
                            fontWeight={`bold`}
                            textTransform={'uppercase'}
                        >
                            Cores Geradas por IA
                        </Text>

                        <Button
                            variant={'link'}
                            onClick={() => {
                                onGenereteColors()
                            }}
                        >
                            Gerar novas cores
                        </Button>
                    </HStack>
                </GridItem> */}
                {/* {generated?.geradas.map((c, k) => (
                    <GridItem
                        key={k.toString()}
                        colSpan={{ base: 1, md: 1 }}
                    >
                        <Box
                            borderRadius={36}
                            borderWidth={1}
                            borderColor={index === c ? c : 'transparent'}
                            p={0.5}
                        >
                            <Box
                                {...rest}
                                w={`35px`}
                                h={`35px`}
                                bg={c}
                                borderRadius={36}
                                display={`flex`}
                                alignItems={`center`}
                                justifyContent={`center`}
                                _hover={{
                                    cursor: 'pointer'
                                }}
                                onClick={() => {
                                    setIndex(c)
                                    onChange(c)
                                }}
                            >
                                {index && index === c &&

                                    <Icon
                                        as={FiCheck}
                                        color={`white`}
                                        fontVariant={`solid`}
                                        w={'20px'}
                                        h={'20px'}
                                    />
                                }
                            </Box>
                        </Box>
                    </GridItem>
                ))} */}
            </Grid>
            {error &&
                <FormHelperText color={`red.500`}>*&nbsp;{error}</FormHelperText>
            }
        </FormControl>
    )
}
